import { render } from "./Section.vue?vue&type=template&id=7868fad4&scoped=true"
const script = {}

import "./Section.vue?vue&type=style&index=0&id=7868fad4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7868fad4"]])

export default __exports__